import React from 'react';
import { Circle, Marker, Popup } from 'react-leaflet';
import MapSurface from '../../../components/customs/map/MapSurface';

interface StaticMapProps {
    latitude: number;
    longitude: number;
    location?: string;
    radius?: number;
    height?: string;
    className?: string;
}

const StaticMap: React.FC<StaticMapProps> = ({
    latitude,
    longitude,
    location,
    radius,
    height = '200px',
    className = ''
}) => {
    const mapZoom = radius && radius >= 1000 ? 12 : radius && radius >= 500 ? 13 : 14;

    return (
        <div
            className={`mb-4 ${className}`}
            style={{
                height,
                borderRadius: '8px',
                overflow: 'hidden',
                pointerEvents: 'none'
            }}
        >
            <MapSurface
                initialViewport={{ center: [latitude, longitude], zoom: mapZoom }}
                mode="readonly"
                style={{ height: '100%', width: '100%' }}
            >
                {radius && radius > 0 ? (
                    <Circle
                        center={[latitude, longitude]}
                        radius={radius}
                        pathOptions={{ color: "#059669", fillColor: "#34d399", fillOpacity: 0.12, weight: 2 }}
                    />
                ) : null}                <Marker position={[latitude, longitude]}>
                    <Popup>{location || 'Location'}</Popup>
                </Marker>
            </MapSurface>
        </div>
    );
};

export default StaticMap;
